export default __webpack_public_path__ + "static/media/doctor.115d0975.PNG";